/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Clients from "layouts/crm/clients";
import Services from "layouts/crm/services";
import Templates from "layouts/crm/templates";
import ServicesTypes from "layouts/crm/services-types";

import Tests from "layouts/crm/tests";
import SignIn from "layouts/authentication/sign-in";

import Icon from "@mui/material/Icon";
import ClientView from "layouts/crm/client-view";
import Protected from "components/Protected";

const routes = [
  {
    type: "collapse",
    name: "Κεντρική Οθόνη",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <Protected>
        <Dashboard />
      </Protected>
    ),
  },
  {
    type: "collapse",
    name: "Πελάτες",
    key: "Πελάτες",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/clients",
    component: (
      <Protected>
        <Clients />
      </Protected>
    ),
  },
  {
    type: "route",
    name: "Καρτέλα Πελάτη",
    key: "client-view",
    route: "/client-view/:id",
    component: (
      <Protected>
        <ClientView />
      </Protected>
    ),
  },
  {
    type: "collapse",
    name: "Υπηρεσίες",
    key: "services",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/services",
    component: (
      <Protected>
        <Services />
      </Protected>
    ),
  },

  // ΝΕΟ: Ομαδοποίηση κάτω από "Ρυθμίσεις"
  {
    type: "collapse",
    name: "Ρυθμίσεις",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "Πρότυπα",
        key: "templates",
        icon: <Icon fontSize="small">receipt_long</Icon>,
        route: "/templates",
        component: (
          <Protected>
            <Templates />
          </Protected>
        ),
      },
      {
        type: "collapse",
        name: "Τύποι Υπηρεσιών",
        key: "services-types",
        icon: <Icon fontSize="small">receipt</Icon>,
        route: "/services-types",
        component: (
          <Protected>
            <ServicesTypes />
          </Protected>
        ),
      },
    ],
  },

  /**
   {
    type: "collapse",
    name: "Δοκομές Tests",
    key: "tests",
    icon: <Icon fontSize="small">receipt</Icon>,
    route: "/tests",
    component: (
      <Protected>
        <Tests />
      </Protected>
    ),
  },*/

  {
    type: "route",
    name: "Sign In",
    key: "auth-sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
